// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Context from "../../provider/Context.bs.js";
import * as Caml_option from "@rescript/std/lib/es6/caml_option.js";
import * as Util_Nullable from "../../util/Util_Nullable.bs.js";
import * as Layout_Program from "../layout/Layout_Program.bs.js";
import * as Type_Page_Program from "../../type/Type_Page_Program.bs.js";

function defaultOnPlayNextChange(param) {
  
}

function ensureOnPlayNextChange(onPlayNextChange) {
  return Util_Nullable.getOrElse(defaultOnPlayNextChange, onPlayNextChange);
}

function ensureIsPlayNextActivated(bool) {
  if (!(bool == null) && bool) {
    return /* On */0;
  } else {
    return /* Off */1;
  }
}

var Autoplay = {
  defaultOnPlayNextChange: defaultOnPlayNextChange,
  ensureOnPlayNextChange: ensureOnPlayNextChange,
  ensureIsPlayNextActivated: ensureIsPlayNextActivated
};

function Page_Program_Presse(Props) {
  var isPlayNextActivated = Props.isPlayNextActivated;
  var onPlayNextChange = Props.onPlayNextChange;
  var page = Props.page;
  var playedProgramId = Props.playedProgramId;
  var player = Props.player;
  var match = Context.I18n.getState(undefined);
  var formaters = match.formaters;
  var match$1 = Context.Config.getState(undefined);
  var layout = Type_Page_Program.makeFromPresse(match.labels, page, formaters.availabilityDate, formaters.betweenDates, formaters.nextBroadcastDate, match$1.serverTime);
  var tmp = {
    isPlayNextActivated: ensureIsPlayNextActivated(isPlayNextActivated),
    onPlayNextChange: Util_Nullable.getOrElse(defaultOnPlayNextChange, onPlayNextChange),
    layout: layout,
    player: player
  };
  if (playedProgramId !== undefined) {
    tmp.playedProgramId = Caml_option.valFromOption(playedProgramId);
  }
  return React.createElement(Layout_Program.make, tmp);
}

var make = Page_Program_Presse;

export {
  Autoplay ,
  make ,
}
/* react Not a pure module */
